import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Dialog } from "primereact/dialog";

import { AutoCompleteField, Button } from "../helpers";

import { raiseToast } from "../services/redux/reducers/toast/toast";

import "../index.css"

const SACCode = (props) => {

    const { selectedSACCode } = props

    const [searchedSACCodes, setSearchedSACCodes] = useState([])

    const dispatch = useDispatch()

    const handleSubmitOrCloseSACCode = () => {
        if(!props.selectedSACCode){
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select SAC Code", life: 3000 }))
        }

        props.setVisibleSACCode(false)
    }

    const searchSACCodes = (event) => {
        const relatedSACCodes = props.SACCodesData.filter(eachHSN => eachHSN.HSNCode.toString().includes(event.query))
        setSearchedSACCodes([...relatedSACCodes])
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex align-items-center">
                <div>{item.HSNCode} - {item.HSNTitle}</div>
            </div>
        )
    }

    return(
        <Dialog header={"SACCode"} style={{ width: '40vw',minHeight:"20%" }} visible={props.visibleSACCode} onHide={() => handleSubmitOrCloseSACCode()}>
            <div className="flex flex-column">
                <div className="flex align-items-center">
                    <AutoCompleteField name="SACCode" style={{ width: "100px" }} field="HSNCode" value={selectedSACCode} onChange={(e) => props.setSelectedSACCode(e.value)} itemTemplate={itemTemplate} suggestions={searchedSACCodes} searchMethod={searchSACCodes} dropdown forceSelection required />
                    {
                        selectedSACCode ? <p className='pl-2' style={{ fontSize: "12px" }}>{selectedSACCode.HSNTitle}</p> : null
                    }
                </div>
            </div>
            <div className='flex flex-row justify-content-end'>
                <Button className="mt-2" label="SUBMIT" outlined onClick={() => handleSubmitOrCloseSACCode()} />
            </div>
        </Dialog>
    )
}

export default SACCode